import * as Sentry from '@sentry/react';
import { ErrorInfo } from 'react';

interface ILoggerProps {
  name: string;
  message?: any;
}
export function logger(props: ILoggerProps): void {
  const { name, message } = props;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (['development', 'local', 'staging', 'sandbox'].includes(process.env.REACT_APP_ENVIRONMENT)) {
    console.log(`WidgetShell ==> ${name} ==> ${message || ''}`);
  }

  try {
    Sentry.setTag('name', name);

    if (message && typeof message === 'string') {
      Sentry.setTag(name, message);
    }
    if (message && typeof message !== 'string') {
      Object.keys(message).forEach(key => {
        // eslint-disable-next-line no-undef
        Sentry.setTag(key, message[key]);
      });
    }

    if (message && message.data && typeof message.data === 'string') {
      Sentry.setTag(name, message.data);
    }
    if (message && message.data && typeof message.data !== 'string') {
      Object.keys(message.data).forEach(key => {
        if (typeof message.data[key] === 'string') {
          // eslint-disable-next-line no-undef
          Sentry.setTag(key, message.data[key]);
        }
      });
    }

    if (message && message.errors && typeof message.errors === 'string') {
      Sentry.setTag(name, message.errors);
    }
    if (message && message.errors && typeof message.errors !== 'string') {
      Object.keys(message.errors).forEach(key => {
        if (typeof message.errors[key] === 'string') {
          // eslint-disable-next-line no-undef
          Sentry.setTag(key, message.errors[key]);
        }
      });
    }

    // eslint-disable-next-line no-undef
    Sentry.captureMessage('WidgetShell: ' + name);
  } catch {}
}

export function loggerError(error: Error, errorInfo?: ErrorInfo): void {
  if (error.message) {
    Sentry.setTag('error.message', error.message);
  }

  if (error.stack) {
    Sentry.setTag('error.stack', error.stack);
  }
  if (error.name) {
    Sentry.setTag('error.name', error.name);
  }
  if (errorInfo) {
    Sentry.setTag('errorInfo', JSON.stringify(errorInfo));
  }
  Sentry.captureException(error);
}
